import React from "react";

const AdminHeader = ({ onMenuToggle, activePage, user, onLogout }) => {
  const isAdmin = user?.role === "admin" || user?.role === "manager";

  const titles = isAdmin
    ? {
        dashboard: "Admin Dashboard",
        leads: "Leads Management",
        calls: "Call Logs",
        tasks: "Task Management",
        team: "Team Members",
        accounting: "Accounting & Invoicing",
        reports: "Reports & Analytics",
      }
    : {
        dashboard: "My Dashboard",
        "my-tasks": "My Tasks",
      };

  const userName = user?.name || "User";

  return (
    <header className="admin-header">
      <div className="admin-header-left">
        <button className="admin-header-menu-btn" onClick={onMenuToggle}>☰</button>
        <div className="admin-header-title">
          <h2>{titles[activePage] || "Dashboard"}</h2>
          <p>Welcome, {userName} 👋</p>
        </div>
      </div>

      <div className="admin-header-right">
        {/* Role Badge */}
        <span style={{
          padding: "4px 12px",
          borderRadius: 9999,
          fontSize: 11,
          fontWeight: 700,
          backgroundColor: isAdmin ? "#eff6ff" : "#f0fdf4",
          color: isAdmin ? "#1e40af" : "#166534",
          border: `1px solid ${isAdmin ? "#bfdbfe" : "#bbf7d0"}`,
        }}>
          {isAdmin ? "👑 " : "👤 "}{user?.role || "sales"}
        </span>

        <button className="admin-logout-btn" onClick={onLogout}>
          🚪 Logout
        </button>
      </div>
    </header>
  );
};

export default AdminHeader;